import { isUndefined } from 'lodash'

export const MODULE_REFERERS = {
  WIDGET: 'Jira issue',
  GADGET: 'Dashboard',
  CONFLUENCE: 'Confluence gadget'
}

// const REFERRERS = {
//   'jira:dashboardGadget': 'Dashboard',
//   'jira:issueContext': 'Jira issue',
//   'jira:globalPage': 'JIRA APP',
//   [CONFLUENCE_MACRO_MODULE_TYPE]: 'Confluence gadget',
//   /* outdated connect app types */
//   jiraDashboardItems: 'Dashboard',
//   webPanels: 'Jira issue',
//   dynamicContentMacros: 'Confluence gadget'
// }

const NO_REFERER = null

const { setRefererModuleName, getRefererModuleName } = (() => {
  let moduleName

  return {
    setRefererModuleName(v) {
      if (!isUndefined(moduleName)) {
        throw new Error('setRefererModuleName can only be called once')
      }

      if (!Object.values(MODULE_REFERERS).includes(v)) {
        throw new TypeError('Invalid referer module name')
      }

      moduleName = v
    },
    getRefererModuleName({ isJiraApp = true } = {}) {
      if (isJiraApp) {
        return moduleName ?? NO_REFERER
      }

      return NO_REFERER
    }
  }
})()

export { setRefererModuleName, getRefererModuleName }
